// extracted by mini-css-extract-plugin
export default {"restrictedUpload":"LockedFiles_restrictedUpload__dfCzV","attachments":"LockedFiles_attachments__E+1HQ"};